module.exports = __webpack_public_path__ + "static/ally-icon-indicator-low.237e696b1522cab720d64ac57021b3bc.svg";